import React from "react";
import direction from "../../../service/direction.json";
import dataPanel from "../../../service/dataPanel.json";
const MyCustomer = () => {
  return (
    <div>
      <div className="text-center text-bold" style={{ fontSize: "30px" }}>
        برخی از مشتریان ما
      </div>
      <div className="form-group row text-center col-md-12 ">
        {dataPanel.myCustomers.map((p, i) => (
          <div className="row col-md-2">
            <img
              classname="img"
              src={direction.ImgmyCustomers + p.img}
              alt="سایه بان"
              style={{ width: "100px", height: "100px" }}
            ></img>
          </div>
        ))}
      </div>
    </div>
  );
};

export default MyCustomer;
